// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// auth

// components


// ----------------------------------------------------------------------


const StyledLogo = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'left',
    marginBottom: 0.5,
    justifyContent: 'left',
    padding: theme.spacing(1, 1.5),
    backgroundColor: '#64b5f6',
}));
// ----------------------------------------------------------------------

export default function NavAccount() {
  

  return (
   
          <StyledLogo>
              <Box sx={{ ml: 2 }}>
                  <Typography variant="subtitle1" noWrap sx={{ color: 'white', fontWeight: 700 }}>
                      Smile Automation Pvt Ltd
                  </Typography>
                  <Typography variant="subtitle2" noWrap sx={{ color: 'white', fontWeight: 600 }}>
                      Admin
                  </Typography>
              </Box>
          </StyledLogo>
  );
}
